import { ShieldCheck, Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface TrustBadgesProps {
  className?: string;
  style?: React.CSSProperties;
}

export default function TrustBadges({ className, style }: TrustBadgesProps) {
  const { t } = useTranslation();
  
  return (
    <div 
      className={`trust-badges-container ${className || ''}`}
      style={style}
    >
      <div className="trust-badge badge-green">
        <Lock size={13} strokeWidth={2.5} />
        <span>{t('trustBadges.sslSecured')}</span>
      </div>
      <div className="trust-badge badge-indigo">
        <ShieldCheck size={13} strokeWidth={2.5} />
        <span>{t('trustBadges.enterpriseSecurity')}</span>
      </div>
      <a 
        href="https://www.saashub.com/reviio-app?utm_source=badge&utm_campaign=badge&utm_content=reviio-app&badge_variant=color&badge_kind=approved" 
        target="_blank" 
        rel="noopener noreferrer"
        className="trust-badge-link"
      >
        <img 
          src="/images/badges/saashub-approved.png" 
          alt="SaaSHub Approved Badge for Reviio" 
          className="trust-badge-img"
        />
      </a>
    </div>
  );
}

